<template>
    <section class="singpause-schulen-contacts">
        <div class="contacts">
            <h4>Schulpersonal</h4>
            <Table
                bordered
                striped
                small
                showFilter
                :responsive="true"
                :fields="fields"
                :items="items"
                :isBusy="busy"
                :size="size"
                sortBy="from_date"
                emptyText="Es wurden bisher keine Zuweisungen von Klassen für diese Schule vorgenommen"
            >
                <!--<template v-slot:thead-top="{ data }">
                    <b-tr>
                        <b-td :colspan="data.columns - 1"></b-td>
                        <b-td class="text-center">
                            <b-button
                                v-if="checkRight('write')"
                                :size="size"
                                @click="duplicateItem(row.id)"
                                variant="link"
                                :disabled="true"
                                class="mv-table-action-btn"
                                >Alle Übertragen</b-button
                            >
                            <b-button
                                v-if="checkRight('write')"
                                :size="size"
                                @click="duplicateItem(row.id)"
                                variant="link"
                                :disabled="true"
                                class="mv-table-action-btn"
                                >Alle Veträge drucken</b-button
                            >
                        </b-td>
                    </b-tr>
                </template>-->
                <template v-slot:mitglied_name="{ row: row }">
                    <b-link
                        :to="{ path: '/mitglieder/' + row.item.mitglied_id }"
                        >{{ row.value }}</b-link
                    >
                </template>
                <template v-slot:honorar="{ row: row }">
                    {{ currency(row.value) }}
                </template>

                <template v-slot:from_date="{ row: row }">
                    {{ $moment(row.value).format("MM/Y") }}
                </template>

                <template v-slot:to_date="{ row: row }">
                    {{ $moment(row.value).format("MM/Y") }}
                </template>

                <template v-slot:honorar_total="{ row: row }">
                    {{ currency(row.item.honorar_zeitraum) }}
                </template>

                <template v-slot:inactive="{ row: row }">
                    <input
                        type="checkbox"
                        v-model="row.item.inactive"
                        :disabled="true"
                        true-value="1"
                        false-value="0"
                    />
                </template>
                <template v-slot:actions="{ row: row }">
                    <b-button
                        v-if="checkRight('write')"
                        :size="size"
                        @click="duplicateItem(row.id)"
                        variant="link"
                        :disabled="true"
                        class="mv-table-action-btn"
                        >Übertragen</b-button
                    >
                    <b-button
                        v-if="checkRight('write')"
                        :size="size"
                        @click="duplicateItem(row.id)"
                        variant="link"
                        :disabled="true"
                        class="mv-table-action-btn"
                        >Vertrag drucken</b-button
                    >
                    <b-button
                        v-if="checkRight('delete')"
                        :size="size"
                        @click="removeItem(row.id)"
                        variant="link"
                        class="text-danger mv-table-action-btn"
                        >Löschen</b-button
                    >
                </template>

                <!--<template v-slot:custom-foot>
                    <b-tr>
                        <b-td>Neuen Datensatz anlegen:</b-td>
                        <b-td>
                            <b-select
                                :options="schools.data"
                                :size="size"
                                :disabled="
                                    busy || schools.busy || validate.busy
                                "
                                v-model="newItem.current.schule_id"
                            ></b-select>
                            <template v-if="validate.errors.schule_id">
                                <p
                                    class="small text-danger m-0 p-0"
                                    v-for="error in validate.errors.schule_id"
                                    :key="error"
                                >
                                    {{ error }}
                                </p>
                            </template>
                        </b-td>
                        <b-td>
                            <b-input
                                :size="size"
                                :disabled="busy || validate.busy"
                                placeholder="z.B. 5"
                                v-model="newItem.current.klassen"
                            />
                            <template v-if="validate.errors.klassen">
                                <p
                                    class="small text-danger m-0 p-0"
                                    v-for="error in validate.errors.klassen"
                                    :key="error"
                                >
                                    {{ error }}
                                </p>
                            </template>
                        </b-td>
                        <b-td>
                            <b-input-group :size="size" append="€"
                                ><b-input
                                    :disabled="busy || validate.busy"
                                    v-model="newItem.current.honorar"
                            /></b-input-group>
                            <template v-if="validate.errors.honorar">
                                <p
                                    class="small text-danger m-0 p-0"
                                    v-for="error in validate.errors.honorar"
                                    :key="error"
                                >
                                    {{ error }}
                                </p>
                            </template>
                        </b-td>
                        <b-td>
                            <SchoolYearDateInput
                                :size="size"
                                :disabled="busy || validate.busy"
                                :school_year="selectedSchoolYear"
                                v-model="newItem.current.from_date"
                            />
                            <template v-if="validate.errors.from_date">
                                <p
                                    class="small text-danger m-0 p-0"
                                    v-for="error in validate.errors.from_date"
                                    :key="error"
                                >
                                    {{ error }}
                                </p>
                            </template>
                        </b-td>
                        <b-td>
                            <SchoolYearDateInput
                                :size="size"
                                :disabled="busy || validate.busy"
                                :school_year="selectedSchoolYear"
                                v-model="newItem.current.to_date"
                            />
                            <template v-if="validate.errors.to_date">
                                <p
                                    class="small text-danger m-0 p-0"
                                    v-for="error in validate.errors.to_date"
                                    :key="error"
                                >
                                    {{ error }}
                                </p>
                            </template>
                        </b-td>
                        <b-td class="text-center"
                            ><input
                                type="checkbox"
                                :size="size"
                                :disabled="busy || validate.busy"
                                true-value="1"
                                false-value="0"
                                v-model="newItem.current.inactive"
                        /></b-td>
                        <b-td
                            ><b-button
                                variant="link"
                                :size="size"
                                :disabled="busy || validate.busy"
                                @click="addItem"
                                >Anlegen</b-button
                            ></b-td
                        >
                    </b-tr>
                </template>-->
            </Table>
        </div>
    </section>
</template>

<script>
import shortid from "shortid";
import CommonView from "@/mixins/CommonView/CommonView";
import Size from "@/mixins/Size/Size";
import Currency from "@/mixins/Currency/Currency";
import SingPause from "@/mixins/SingPause/SingPause";
import { ApiFactory } from "@/api/ApiFactory.js";
import Table from "@/components/Table/Table";
import SchoolYearDateInput from "@/components/SchoolYearDateInput/SchoolYearDateInput";

const SingPauseApi = ApiFactory.get("singpause");

export default {
    name: "SingPauseSchulenContacts",
    mixins: [CommonView, Size, Currency, SingPause],
    props: ["id", "schools", "refresh"],
    components: {
        Table
        // SchoolYearDateInput
    },
    data() {
        return {
            api: SingPauseApi,
            fields: [
                {
                    key: "id",
                    label: "ID",
                    sortable: true
                },
                {
                    key: "mitglied_name",
                    label: "Mitarbeiter",
                    sortable: true
                },
                {
                    key: "funktion",
                    label: "Position",
                    class: "text-center"
                }
                /*{
                    key: "actions",
                    label: "Aktionen",
                    class: "text-center"
                }*/
            ]
            /*newItem: {
                default: {
                    id: null,
                    schule_id: null,
                    klassen: null,
                    honorar: null,
                    from_date: null,
                    to_date: null,
                    inactive: false
                },
                current: {
                    id: null,
                    schule_id: null,
                    klassen: null,
                    honorar: null,
                    from_date: null,
                    to_date: null,
                    inactive: false
                }
            },*/
            /*validate: {
                busy: false,
                errors: {}
            }*/
        };
    },
    watch: {
        selectedSchoolYear: {
            handler() {
                this.fetch();
            }
        },
        refresh: {
            handler() {
                this.fetch();
            }
        }
    },
    methods: {
        async fetch() {
            this.busy = true;
            const response = await this.api.getContactsForSchule(
                this.id,
                this.selectedSchoolYear
            );
            if (response.ok && response.json.collection) {
                var items = response.json.collection;
                items = items.map(item => this.process(item));
                this.items = items;
                this.registerRights(response);
            } else {
                this.items = [];
                this.registerRights(response);
            }
            this.busy = false;
        }
        /*async addItem() {
            this.newItem.current["id"] = "new_" + shortid.generate();
            const school = this.schools.data.filter(
                item => item.value == this.newItem.current["schule_id"]
            );
            if (school.length > 0) {
                this.newItem.current["schule_name"] = school[0]["text"];
            }
            this.validate.busy = true;
            const validate = await SingPauseApi.validateKlassen(
                this.id,
                this.newItem.current
            );
            if (validate.ok) {
                this.items.push(this.newItem.current);
                this.newItem.current = { ...this.newItem.default };
            } else {
                console.error("Validaton error:", validate);
                this.validate.errors = validate.json.validation;
            }
            this.validate.busy = false;
        },
        removeItem(id) {
            this.items = this.items.filter(item => item.id !== id);
        }*/
    }
};
</script>
